import type { CSSProperties, ReactNode } from 'react';

/**
 * The recurring white surface card used across the app: white background,
 * hairline border, small radius. Pass `style`/`className` to extend it.
 */
export function Card({
  children,
  style,
  className = '',
  onClick,
  id,
}: {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
  /** Scroll target, for a link elsewhere on the page that points at this card. */
  id?: string;
}) {
  return (
    <div
      id={id}
      className={className}
      onClick={onClick}
      style={{
        background: '#FFFFFF',
        border: '1px solid #E3D9CC',
        borderRadius: 4,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
